const ACCEPTED_IMAGE_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp'])
const ACCEPTED_IMAGE_EXTENSIONS = '.jpg,.jpeg,.png,.webp'
const MAX_FILE_SIZE_BYTES = 25 * 1000 * 1000

export function isAcceptedBackgroundRemoverFile(file: File) {
  return ACCEPTED_IMAGE_TYPES.has(file.type) && file.size <= MAX_FILE_SIZE_BYTES
}

export { ACCEPTED_IMAGE_EXTENSIONS }
